export default {
    props: {
        enabled: {
            type: Boolean,
            default: true,
        },
        height: {
            type: Function,
            default: el => (el.scrollHeight) + 'px'
        },
    },
    data() {
        return {
            lastText: null
        }
    },
    methods: {
        resizer() {
            let currentHeight = this.$el.style.height
            this.$el.style.height = 'auto'
            let newHeight = this.height(this.$el)
            this.$el.style.height = newHeight
            this.lastText = this.$el.value
            if (currentHeight !== newHeight) {
                this.$emit('textarea:heightAdjusted', this)
            }
        },
        resizeTextarea() {
            if (!this.enabled) return;
            if (this.lastText === this.$el.value) {
                return
            }
            this.resizer()
        },
        forceResize() {
            this.lastText = this.$el.value;
            let h = this.height(this.$el);
            let style = this.$el.getAttribute('style');
            style = style ? style : ''
            let regex = /height:[*.];/i
            style = style.replace(regex, 'style').trim();
            if (style !== '') {
                style += ';'
            }
            if (h === '0px') {
                this.$el.setAttribute('style', style + 'height:auto;')
            } else {
                this.$el.setAttribute('style', style + 'height:' + h + ';overflow-y:hidden;')
            }
        }
    },
    mounted() {
        this.$el.addEventListener('input', this.resizeTextarea)
        this.$el.addEventListener('change', this.resizeTextarea)
        this.forceResize();
        this.$nextTick(() => {
            this.forceResize();
        })
    },
    beforeDestroy() {
        this.$el.removeEventListener('input', this.resizeTextarea)
        this.$el.removeEventListener('change', this.resizeTextarea)
    },
    render() {
        return this.$slots.default[0]
    },
}
